export default "__VITE_ASSET__1fe0378e__"